import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type DisputeStatus = 'open' | 'accepted' | 'rejected' | 'resolved';

export interface DisputeApiItem {
  _id: string;
  custom_dispute_id: string;
  approval_id?: string;
  custom_approval_id?: string;
  ticket_id?: string;
  custom_ticket_id?: string;
  claim_number?: string;
  department_name?: string;
  against_user_id?: string;
  against_user_name?: string;
  dispute_person_id?: string;
  dispute_person_name?: string;
  raised_by_id?: string;
  raised_by_name?: string;
  reason: string;
  status: DisputeStatus;
  resolution_remarks?: string;
  resolved_at?: string;
  resolved_by_name?: string;
  raised_at?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface DisputesListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    disputes?: DisputeApiItem[];
    totalCount?: number;
    total?: number;
  };
}

export interface RaiseDisputePayload {
  approval_id: string;
  reason: string;
}

export interface TakeDisputeActionPayload {
  action: 'accepted' | 'rejected' | 'resolved';
  remarks?: string;
}

export interface DisputeMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: DisputeApiItem;
}

export const getMyDisputes = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  status?: DisputeStatus;
}): Promise<DisputesListResponse> => {
  return api.get<DisputesListResponse>(API_ENDPOINTS.disputes.mine, { params });
};

export const getAllDisputes = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  status?: DisputeStatus;
  department_name?: string;
}): Promise<DisputesListResponse> => {
  return api.get<DisputesListResponse>(API_ENDPOINTS.disputes.list, { params });
};

export const raiseDispute = async (payload: RaiseDisputePayload): Promise<DisputeMutationResponse> => {
  return api.post<DisputeMutationResponse, RaiseDisputePayload>(API_ENDPOINTS.disputes.list, payload);
};

export const takeDisputeAction = async (
  disputeId: string,
  payload: TakeDisputeActionPayload,
): Promise<DisputeMutationResponse> => {
  return api.post<DisputeMutationResponse, TakeDisputeActionPayload>(
    `${API_ENDPOINTS.disputes.list}/${disputeId}/action`,
    payload,
  );
};
